/**
 * User: nir
 * Date: 07/11/2016
 * Time: 23:06
 */
var url = window.location.href;
window.TCT = window.TCT || {};
window.TCT.Sharing = window.TCT.Sharing || {
  prepareEmailShare: function(title, postId, anchorTag) {
    if (!anchorTag) {
      TCT.warn(
          'Could not prepare email sharing link because anchor tag was not passed');
      return;
    }

    if (!title || !postId) {
      TCT.warn(
          'Could not prepare email sharing link because either title or article ID was not passed');
      return;
    }

    if (!window.branch) {
      TCT.warn(
          'Could not prepare email sharing link because branch js library was not loaded');
      return;
    }

    TCT.debug('Preparing email share for article #' + postId);

    // get universal link from branch.io
    branch.link({
      tags: [],
      channel: 'email',
      feature: 'web share',
      stage: '',
      data: {
        'interrupt branch param': 'culturetrip://interrupt/showArticle?SOURCE=branch&article=' +
        postId,
        '$desktop_url': url,
        '$ios_url': url,
        '$ipad_url': url,
        '$og_title': 'Check out this article from \'Culture Trip\'',
        '$og_description': '\'' + title + '\'',
      },
    }, function(err, link) {
      TCT.debug(err, link);

      if (err !== false) {
        // ignore errors
      } else {
        link = url;
      }

      anchorTag.setAttribute('href', 'mailto:?'
          + '&subject=' + encodeURIComponent(title + ' @ Culture Trip')
          + '&body=' +
          encodeURIComponent('Hey, check out this awesome article on Culture Trip:\n' +
              link));
    });
  },
  shareEmail: function(e) {
    TCT.debug('sharing.js: shareEmail', e);

    if (e && this) {
      var title = this.getAttribute('data-tct-email-share-title');

      trackCTA('CTAShare_Email');
      trackConversion('Share_Email', window.location.href, title);
    }

    return true;
  },
};

if (window.jQuery) {
  window.jQuery(function($) {
    // wait for branch js sdk to be available
    waitForObject('branch', init, fail);

    function fail() {
      TCT.warn('branch js library was not loaded');
    }

    function init() {
      var anchors = $('a[data-tct-email-share-title]');
      anchors.each(function(i, e) {
        var $a = $(e),
            title = $a.attr('data-tct-email-share-title'),
            id = parseInt($a.attr('data-tct-email-share-id'));

        TCT.Sharing.prepareEmailShare(title, id, e);
        $a.on('click', TCT.Sharing.shareEmail);
      });
    }
  });
} else TCT.jQueryWarning();